/**
 * 入庫單來源類型（一般／採購／工單）— UI profile 單一真相。
 * Create／Edit／Detail／列表 filter 共用，避免散落 sourceType === 判斷。
 * PURCHASE／WORK_ORDER 不可改供應商／幣別／進位（見 CreateEdit 鎖定規則）。
 */

export const STOCK_RECEIPT_SOURCE_TYPE = {
  MANUAL: 'MANUAL',
  PURCHASE: 'PURCHASE',
  WORK_ORDER: 'WORK_ORDER',
};

export const STOCK_RECEIPT_SOURCE_TYPE_LABELS = {
  MANUAL: '一般',
  PURCHASE: '採購',
  WORK_ORDER: '工單',
};

export const STOCK_RECEIPT_SOURCE_TYPE_FILTER_OPTIONS = [
  {
    value: STOCK_RECEIPT_SOURCE_TYPE.MANUAL,
    label: STOCK_RECEIPT_SOURCE_TYPE_LABELS.MANUAL,
  },
  {
    value: STOCK_RECEIPT_SOURCE_TYPE.PURCHASE,
    label: STOCK_RECEIPT_SOURCE_TYPE_LABELS.PURCHASE,
  },
  {
    value: STOCK_RECEIPT_SOURCE_TYPE.WORK_ORDER,
    label: STOCK_RECEIPT_SOURCE_TYPE_LABELS.WORK_ORDER,
  },
];

/**
 * @param {string | null | undefined} sourceType
 * @returns {{
 *   sourceType: string,
 *   label: string,
 *   showSupplierField: boolean,
 *   supplierEditable: boolean,
 *   showMoneySection: boolean,
 *   moneyEditable: boolean,
 *   showCommercialLinePricing: boolean,
 *   allowSimpleUnitPrice: boolean,
 *   showInfoCardMoney: boolean,
 *   showInfoCardCurrency: boolean,
 *   showInfoCardSupplier: boolean,
 *   commercialLockTip: string | null,
 *   clearCommercialHeaderOnHydrate: boolean,
 * }}
 */
export function getStockReceiptSourceUiProfile(sourceType) {
  const type = sourceType || STOCK_RECEIPT_SOURCE_TYPE.MANUAL;
  const isManual = type === STOCK_RECEIPT_SOURCE_TYPE.MANUAL;
  const isPurchase = type === STOCK_RECEIPT_SOURCE_TYPE.PURCHASE;
  const isWorkOrder = type === STOCK_RECEIPT_SOURCE_TYPE.WORK_ORDER;

  return {
    sourceType: type,
    label: STOCK_RECEIPT_SOURCE_TYPE_LABELS[type] ?? type,
    showSupplierField: !isWorkOrder,
    supplierEditable: isManual,
    showMoneySection: !isWorkOrder,
    moneyEditable: isManual,
    showCommercialLinePricing: !isWorkOrder,
    allowSimpleUnitPrice: true,
    showInfoCardMoney: !isWorkOrder,
    showInfoCardCurrency: true,
    showInfoCardSupplier: !isWorkOrder,
    commercialLockTip: isPurchase
      ? '此入庫單來自採購，供應商與幣別由採購單帶入，無法在此變更。'
      : isWorkOrder
        ? '此入庫單來自工單（非商業），無供應商與進位；幣別固定為 TWD，不可變更。'
        : null,
    clearCommercialHeaderOnHydrate: isWorkOrder,
  };
}

export function getStockReceiptSourceTypeLabel(sourceType) {
  return getStockReceiptSourceUiProfile(sourceType).label;
}

export function getStockReceiptCommercialLockTip(sourceType) {
  return getStockReceiptSourceUiProfile(sourceType).commercialLockTip;
}
